export const maxLength = 32
export const minLength = 2
